import React, { useEffect, useState } from 'react'

import getMakes, { GetMakesOptions, Make } from 'api/vehicles/getMakes'
import { FormikDropdown } from 'components/FormikFields'

interface BaseMakeDropdownProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formik: any
    dropdownType: 'marine' | 'vehicle'
    dataSource?: string[]
    assetType?: string
    assetSubType?: unknown
    disable?: boolean
    primaryVehicleId?: number
    fieldNamePrefix: string
}

const defaultProps = {
    dataSource: null,
    assetSubType: null,
    disable: false,
    primaryVehicleId: null,
    assetType: '',
}

export default function BaseMakeDropdown({
    formik,
    dataSource,
    assetType,
    assetSubType,
    disable,
    primaryVehicleId,
    fieldNamePrefix,
    dropdownType,
}: Readonly<BaseMakeDropdownProps>) {
    const [response, updateResponse] = useState([] as Make[])
    const values = formik.values[fieldNamePrefix]
    const { condition, year, make } = values
    const fieldName = `${fieldNamePrefix}.make`

    useEffect(() => {
        const abortController = new AbortController()

        if (condition && year) {
            const getMakesOptions = {
                condition,
                year,
                dataSource,
                assetType,
                assetSubType,
                ...(dropdownType === 'marine'
                    ? { boatType: values.type }
                    : {
                          primaryVehicleId,
                      }),
                disable,
            } as GetMakesOptions

            getMakes(getMakesOptions, abortController)
                .then((makes: Make[]) => {
                    updateResponse(makes)
                    if (
                        makes.filter((e) => `${e.name}` === make).length === 0
                    ) {
                        formik.setFieldValue(fieldName, '')
                    }
                })
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                .catch(() => {})
        }

        return () => abortController.abort()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [condition, year])

    if (!year || year === '0') {
        return (
            <FormikDropdown
                name={fieldName}
                label="Make"
                placeholder="Select One"
                disabled
            >
                {[{ name: '', value: '' }]}
            </FormikDropdown>
        )
    }

    return (
        <FormikDropdown
            name={fieldName}
            label={dropdownType === 'marine' ? 'Hull Makes' : 'Make'}
            placeholder="Select One"
            disabled={response.length === 0}
            error={make === null || make === ''}
        >
            {response.map((child: Make) => ({
                name: child.name,
                value: child.name,
            }))}
        </FormikDropdown>
    )
}

BaseMakeDropdown.defaultProps = defaultProps
